import React, {Component} from 'react';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
import {withSnackbar} from 'notistack';
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import {Typography} from "@material-ui/core";
import PlaylistList from "./PlaylistList";
import TextField from "@material-ui/core/TextField";
import ThumbnailUploader from "./ThumbnailUploader";
import PlaylistMomentClips from "./PlaylistMomentClips";
import Button from "@material-ui/core/Button";
import MomentService from "../Services/MomentsService";
import ClipMomentSearch from "./MomentClipSearch";
import showSnackBar from "../Utilities/SnackbarHelper";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import {ERROR, SUCCESS, WARNING} from "../constants";
import {handleReOrder} from "../Utilities/List";
import {capitalizeFirstLetter} from "../Utilities/StringUtils"
import MUIDataTable from "mui-datatables";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import EmojiEventIcon from "@material-ui/icons/EmojiEvents";
import LinearProgress from "@material-ui/core/LinearProgress";


const styles = theme => ({
    container: {
        position: 'relative',
        minHeight: "100vh"
    },
    searchBar: {
        flex: 1
    },
    playlistClipMomentsContainer: {
        minHeight: "30vh"
    },
    formTitle: {},
    momentIdInput: {
        marginTop: "-13px"
    },
    thumbnailContainerCard: {
        display: "inline",
        marginRight: theme.spacing(1)
    }
});


class Competition extends Component {


    constructor(props) {
        super(props);

        this.state = {
            statistics: null,
        };

        this.columns = [
            {
                label: 'User',
                name: "user",
                options: {
                    filter: false,
                    download: false,
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return(
                            <>
                                {value === sessionStorage.userEmail &&
                                    <b>{value}</b>
                                }
                                {value !== sessionStorage.userEmail &&
                                    <>{value}</>
                                }

                            </>
                        );

                    }
                }
            },
            {
                label: 'Count',
                name: "count"
            },
            {
                label: 'Level',
                name: "level",
            },
            {
                label: 'Awards',
                name: "badges",
                options: {
                    filter: false,
                    download: false,
                    customBodyRender: (value) => {

                        let badge =  value;
                        let badges = [];

                        for (let i = 0; i < badge; i++) {
                            badges.push({});
                        }
                        
                        return (
                            <>
                                {badges.map(()=>{
                                    return <EmojiEventIcon fontSize={"small"} color={"primary"}/>
                                })}
                            </>
                        );

                    }
                }
            },

        ];

        this.options = {
            filterType: 'textField',
            pagination: false,
            selectableRows: 'none',
            print: false,
            viewColumns: false,
            responsive: 'stacked'
        };
    }


    componentDidMount() {
        this.loadStatistics();
    }

    loadStatistics() {
        let self = this;
        let serviceToUse = null;
        if (this.props.mode === "momentClips") {
            serviceToUse = MomentService.getMomentClipsCount();
        }else {
            serviceToUse = MomentService.getMomentsCount();
        }

        serviceToUse.then((response) => {
                if (response && response.data && response.data.entity && response.data.entity.length > 0) {
                    let statistics = _.orderBy(response.data.entity, ['count'],['desc']);
                    self.setState({statistics:statistics});
                } else {
                    if (response && response && (response.responseType === "SUCCESS")) {
                        let statistics = _.orderBy(response.entity, ['count'],['desc']);
                        self.setState({statistics: statistics});
                    }
                }
            });
    }

    componentWillUnmount() {

    }


    render() {

        const {classes, theme} = this.props;

        let formTitle = `Who would be the moments champion?`;
        let statsTableTitle = ``;
        if (this.props.mode === "momentClips") {
            statsTableTitle = `Total Clip Moments by Users`;
        }else{
            statsTableTitle = `Total Moments Playlists by Users`;
        }

        return <React.Fragment>


                <Card>
                    <CardHeader className={classes.formTitle} title={formTitle}
                                action={
                                    <IconButton aria-label="delete" onClick={this.props.closeCompetition.bind(this)}>
                                        <CloseIcon fontSize="small"/>
                                    </IconButton>
                                }/>
                    <CardContent>

                        {(this.state.statistics) &&
                        <>
                            <MUIDataTable
                                title={statsTableTitle}
                                data={this.state.statistics}
                                columns={this.columns}
                                options={this.options}
                            />
                        </>
                        }
                        {(!this.state.statistics) &&
                            <LinearProgress/>
                        }

                    </CardContent>
                </Card>


        </React.Fragment>
    }
}


Competition.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default (withStyles(styles, {withTheme: true})(withSnackbar(Competition)));